import {MtcTableColumnInterface} from "../interfaces";

interface OrderTrackingStep {
  label: string;
  planField: string;
  actualField: string | null;
  tooltip?: string;
}

interface OrderTrackingConfigInterface {
  tableColumns: Array<MtcTableColumnInterface>;
  steps: Array<OrderTrackingStep>;
}

const formatDateValue = (value: unknown): string => {
  return value ? String(value) : "-";
};

export const OrderTrackingConfig: OrderTrackingConfigInterface = {
  tableColumns: [
    {
      header: "Step",
      width: "33%",
      field: "orderTrackingStep",
      disableSort: true
    },
    {
      header: "Plan",
      width: "33%",
      field: "orderTrackingPlan",
      disableSort: true,
      transform: formatDateValue
    },
    {
      header: "Is",
      width: "34%",
      field: "orderTrackingActual",
      disableSort: true,
      transform: formatDateValue
    }
  ],
  steps: [
    {label: "Order", planField: "orderDate", actualField: "orderDate"},
    {
      label: "Sales Order Freeze",
      planField: "sofPlan",
      actualField: "sofAct",
      tooltip: "Actual Sales Order Freeze in SAP:<br>{sofPlanDate}"
    },
    {label: "Production Freeze", planField: "pfPlan", actualField: "pfAct"},
    {label: "Start of Production", planField: "sopPlan", actualField: "sopAct"},
    {label: "End of Production", planField: "eopPlan", actualField: "eopAct"},
    {label: "Shipping Freeze", planField: "sfPlan", actualField: "sfAct"},
    {label: "Ready for Shipment", planField: "rfsPlan", actualField: "rfsAct"},
    {label: "Pick Up Production", planField: "pupPlan", actualField: "pupAct"},
    {label: "Departure Port", planField: "dpPlan", actualField: "dpAct"},
    {label: "Arrival Port", planField: "apPlan", actualField: "apAct"},
    {label: "Arrival Customer", planField: "acPlan", actualField: "acAct"},
    {label: "Begin Start-Up", planField: "bsuPlan", actualField: "bsuAct"},
    {label: "End Start-Up", planField: "esuPlan", actualField: "esuAct"},
    {label: "Up & Running", planField: "runningPlan", actualField: "runningAct"},
    {label: "Final Payment", planField: "finalInvoicePlan", actualField: null}
  ]
};
